var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout fill-height"},[_c('v-app',[_c('v-main',[_c('v-container',{staticClass:"pa-0 fill-height",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }